import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ZSection from './Component/SuperAdmin/ZSection.js';
import LoginForm from './Component/SuperAdmin/SampleLogin/Login.js';
import SZType from './Component/SuperAdmin/SZType.js';
import MenuMaster from './Component/SuperAdmin/MenuMaster.js';
import Authorizations from './Component/SuperAdmin/Authorizations.js';
import AppUser from './Component/SuperAdmin/AppUser.js';
import Dashboard from './Component/SuperAdmin/Dashboard.js';
import CreateProfile from './Component/SuperAdmin/CreateProfile.js';
import ManageSubscriptionRequest from './Component/SuperAdmin/ManageSubscriptionRequest.js';
import ManageAllProperties from './Component/SuperAdmin/ManageAllProperties.js';
import ManageVendors from './Component/SuperAdmin/ManageVendors.js';
import ManageHero  from './Component/SuperAdmin/HeroComponent/ManageHero.js';
import PageURLMaster from './Component/Category/PageURLMaster.js';
import CreateProperty from './Component/Category/CreateProperty.js';
import PageDetail from './Component/Category/PageDetail.js';
import TOC from './Component/Category/TOC.js';
import FAQ from './Component/Category/FAQ.js';
import Meta from './Component/Category/Meta.js';
import Tag from './Component/Category/Tag.js';
import LinkPage from './Component/Category/LinkPage.js';
import ContactUs2 from './Component/SuperAdmin/ContactUs2.js';
import ManageEnquiry from './Component/SuperAdmin/ManageEnquiry.js';
import NotAuthorised from './Component/Layout/NotAuthorised.js';
import State from './Component/SuperAdmin/State.js';
import Cities from './Component/SuperAdmin/Cities.js';
import Area from './Component/SuperAdmin/Area.js';
import ManageBlogs from './Component/SuperAdmin/ManageBlogs.js';
import AMRDetails from './Component/SuperAdmin/AMRDetails.js';
import ManageCategory from './Component/SuperAdmin/ManageCategory.js';
import ManagePageBanner from './Component/SuperAdmin/ManagePageBanner.js';
import AddFAQHead from './Component/SuperAdmin/AddFAQHead.js';
import AddFAQ from './Component/SuperAdmin/AddFAQ.js';
import AddTrustedPartner from './Component/SuperAdmin/AddTrustedPartner.js';
import AddTestimonial from './Component/SuperAdmin/AddTestimonial.js';
import AddPropertyControlType from './Component/SuperAdmin/AddPropertyControlType.js';
import AddPropertyControlName from './Component/SuperAdmin/AddPropertyControlName.js';
import ManageNewsLetter from './Component/SuperAdmin/ManageNewsLetter.js';
import AddPolicies from './Component/SuperAdmin/AddPolicies.js';
import AddAboutUs from './Component/SuperAdmin/AddAboutUs.js';
import AddFilterationCategory from './Component/SuperAdmin/AddFilterationCategory.js';
import AddFiletrationCategoryParentChild from './Component/SuperAdmin/AddFiletrationCategoryParentChild.js';
import ManageFurnishingMaster from './Component/SuperAdmin/ManageFurnishingMaster.js';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('tcn');
  return token ? children : <Navigate to="/not-authorised" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/not-authorised" element={<NotAuthorised />}></Route>
        <Route path="/" element={<LoginForm />}></Route>
        <Route path="/login" element={<LoginForm />}></Route>
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}></Route>
        <Route path="/zsection" element={<ProtectedRoute><ZSection /></ProtectedRoute>}></Route>
        <Route path="/sztype" element={<ProtectedRoute><SZType /></ProtectedRoute>}></Route>
        <Route path="/menumaster" element={<ProtectedRoute><MenuMaster /></ProtectedRoute>}></Route>
        <Route path="/authorizations" element={<ProtectedRoute><Authorizations /></ProtectedRoute>}></Route>
        <Route path="/appuser" element={<ProtectedRoute><AppUser /></ProtectedRoute>}></Route>
        <Route path="/createprofile" element={<ProtectedRoute><CreateProfile /></ProtectedRoute>}></Route>
        <Route path="/managesubscriptionrequest" element={<ProtectedRoute><ManageSubscriptionRequest /></ProtectedRoute>}></Route>
        <Route path="/manageallproperties" element={<ProtectedRoute><ManageAllProperties /></ProtectedRoute>}></Route>
        <Route path="/managevendors" element={<ProtectedRoute><ManageVendors /></ProtectedRoute>}></Route>
        <Route path="/managehero" element={<ProtectedRoute><ManageHero /></ProtectedRoute>}></Route>
        <Route path="/pageurlmaster" element={<ProtectedRoute><PageURLMaster /></ProtectedRoute>}></Route>
        <Route path="/createpropertytype" element={<ProtectedRoute><CreateProperty /></ProtectedRoute>}></Route>
        <Route path="/pagedetail" element={<ProtectedRoute><PageDetail /></ProtectedRoute>}></Route>
        <Route path="/toc" element={<ProtectedRoute><TOC /></ProtectedRoute>}></Route>
        <Route path="/faq" element={<ProtectedRoute><FAQ /></ProtectedRoute>}></Route>
        <Route path="/meta" element={<ProtectedRoute><Meta /></ProtectedRoute>}></Route>
        <Route path="/tag" element={<ProtectedRoute><Tag /></ProtectedRoute>}></Route>
        <Route path="/linkpage" element={<ProtectedRoute><LinkPage /></ProtectedRoute>}></Route>
        <Route path="/contactus" element={<ProtectedRoute><ContactUs2 /></ProtectedRoute>}></Route>
        <Route path="/manageenquiry" element={<ProtectedRoute><ManageEnquiry /></ProtectedRoute>}></Route>
        <Route path="/manageblogs" element={<ProtectedRoute><ManageBlogs /></ProtectedRoute>}></Route>
        <Route path="/amrdetails" element={<ProtectedRoute><AMRDetails /></ProtectedRoute>}></Route>
        <Route path="/state" element={<ProtectedRoute><State /></ProtectedRoute>}></Route>
        <Route path="/cities" element={<ProtectedRoute><Cities /></ProtectedRoute>}></Route>
        <Route path="/area" element={<ProtectedRoute><Area /></ProtectedRoute>}></Route>
        <Route path="/managecategory" element={<ProtectedRoute><ManageCategory /></ProtectedRoute>}></Route>
        <Route path="/managepagebanner" element={<ProtectedRoute><ManagePageBanner /></ProtectedRoute>}></Route>
        <Route path="/addfaqhead" element={<ProtectedRoute><AddFAQHead /></ProtectedRoute>}></Route>
        <Route path="/addfaq" element={<ProtectedRoute><AddFAQ /></ProtectedRoute>}></Route>
        <Route path="/addtrustedpartner" element={<ProtectedRoute><AddTrustedPartner /></ProtectedRoute>}></Route>
        <Route path="/addtestimonial" element={<ProtectedRoute><AddTestimonial /></ProtectedRoute>}></Route>
        <Route path="/addpropertycontroltype" element={<ProtectedRoute><AddPropertyControlType /></ProtectedRoute>}></Route>
        <Route path="/addpropertycontrolname" element={<ProtectedRoute><AddPropertyControlName /></ProtectedRoute>}></Route>
        <Route path="/managenewsletter" element={<ProtectedRoute><ManageNewsLetter /></ProtectedRoute>}></Route>
        <Route path="/addpolicies" element={<ProtectedRoute><AddPolicies /></ProtectedRoute>}></Route>
        <Route path="/addaboutus" element={<ProtectedRoute><AddAboutUs /></ProtectedRoute>}></Route>
        <Route path="/addfilterationcategory" element={<ProtectedRoute><AddFilterationCategory /></ProtectedRoute>}></Route>
        <Route path="/addfiletrationcategoryparentchild" element={<ProtectedRoute><AddFiletrationCategoryParentChild /></ProtectedRoute>}></Route>
        <Route path="/managefurnishingmaster" element={<ProtectedRoute><ManageFurnishingMaster /></ProtectedRoute>}></Route>
        <Route path="*" element={<Navigate to="/not-authorised" replace />}></Route>
      </Routes>      
    </BrowserRouter>
  );
}

export default App;
